import deepmerge from 'deepmerge'

export const copy: <T>(o: T) => T = o => deepmerge({} as any, o)
